(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5345,9008,6511,136,6778],{

/***/ 85353:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product",
      function () {
        return __webpack_require__(94254);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ADDTHIS_ID": function() { return /* binding */ ADDTHIS_ID; },
/* harmony export */   "BOPUS_SHIPPING_DESCRIPTION": function() { return /* binding */ BOPUS_SHIPPING_DESCRIPTION; },
/* harmony export */   "BRAND": function() { return /* binding */ BRAND; },
/* harmony export */   "EXTEND_LOGO": function() { return /* binding */ EXTEND_LOGO; },
/* harmony export */   "EXTEND_SKU": function() { return /* binding */ EXTEND_SKU; },
/* harmony export */   "FOOTER_SECTIONS": function() { return /* binding */ FOOTER_SECTIONS; },
/* harmony export */   "FREE_SHIPPING_AMOUNT": function() { return /* binding */ FREE_SHIPPING_AMOUNT; },
/* harmony export */   "FREE_SHIPPING_DESCRIPTION": function() { return /* binding */ FREE_SHIPPING_DESCRIPTION; },
/* harmony export */   "GIFT_BOX_SKU": function() { return /* binding */ GIFT_BOX_SKU; },
/* harmony export */   "PARKY_CREDIT_CARD_TRANSACTION_METHOD": function() { return /* binding */ PARKY_CREDIT_CARD_TRANSACTION_METHOD; },
/* harmony export */   "PARKY_PAYPAL_TRANSACTION_METHOD": function() { return /* binding */ PARKY_PAYPAL_TRANSACTION_METHOD; },
/* harmony export */   "PLP_Items_Per_Page": function() { return /* binding */ PLP_Items_Per_Page; },
/* harmony export */   "SHIPPED_SHIELD_LOGO": function() { return /* binding */ SHIPPED_SHIELD_LOGO; },
/* harmony export */   "SHIPPED_SHIELD_SKU": function() { return /* binding */ SHIPPED_SHIELD_SKU; },
/* harmony export */   "STANDARD_PLUS_SHIPPING_DESCRIPTION": function() { return /* binding */ STANDARD_PLUS_SHIPPING_DESCRIPTION; },
/* harmony export */   "STANDARD_SHIPPING_DESCRIPTION": function() { return /* binding */ STANDARD_SHIPPING_DESCRIPTION; },
/* harmony export */   "STORE_MAIN_LOGO_URL": function() { return /* binding */ STORE_MAIN_LOGO_URL; },
/* harmony export */   "STORE_MINI_LOGO_URL": function() { return /* binding */ STORE_MINI_LOGO_URL; },
/* harmony export */   "STORE_PHONE": function() { return /* binding */ STORE_PHONE; },
/* harmony export */   "designSkus": function() { return /* binding */ designSkus; },
/* harmony export */   "storeOperationHours": function() { return /* binding */ storeOperationHours; }
/* harmony export */ });
var STORE_PHONE = "(332) 333-6412";
var GIFT_BOX_SKU = "990000007";
var ADDTHIS_ID = "ra-5f4ec39268f6acd2";
var FREE_SHIPPING_AMOUNT = 49.00;
var EXTEND_SKU = ";xtd;";
var SHIPPED_SHIELD_SKU = "SHIPPED_ASSURANCE_";
var BOPUS_SHIPPING_DESCRIPTION = "Zgallerie (BOPS)";
var FREE_SHIPPING_DESCRIPTION = "Free Shipping";
var STANDARD_SHIPPING_DESCRIPTION = "Zgallerie (Standard)";
var STANDARD_PLUS_SHIPPING_DESCRIPTION = "Zgallerie (Standard Plus)";
var STORE_MAIN_LOGO_URL = "https://assets.onekingslane.com/m/2a3672007ee7fa59/original/OKL-logo-reg.png";
var STORE_MINI_LOGO_URL = "data:image/png;base64,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";
var PARKY_CREDIT_CARD_TRANSACTION_METHOD = "Credit Card";
var PARKY_PAYPAL_TRANSACTION_METHOD = "PayPal";
var EXTEND_LOGO = "https://cdn11.bigcommerce.com/s-whvhnri10h/product_images/uploaded_images/extend-logo.png";
var SHIPPED_SHIELD_LOGO = "https://cdn11.bigcommerce.com/s-ccb3mj27tc/products/1821415/images/817186/shield-be9ba978feb179704666141db2d825d1f9d9cc55787fdcbf9885dff04b0dd644__12393.1680276093.220.290.png";
var BRAND = "One Kings Lane";
var PLP_Items_Per_Page = 60;
var FOOTER_SECTIONS = [
    {
        heading: "Our Company",
        links: [
            {
                name: "About Us",
                href: "/about-us"
            },
            {
                name: "Careers",
                href: "/careers"
            },
            {
                name: "Blog",
                href: "https://blog.onekingslane.com/"
            }
        ]
    },
    {
        heading: "Customer Care",
        links: [
            {
                name: "Returns",
                href: "https://returns.narvar.com/okl/returns"
            },
            {
                name: "Order Status",
                href: "/order-status"
            },
            {
                name: "FAQ",
                href: "/faq",
                ariaLabel: "Frequently asked questions"
            },
            {
                name: "Return Policy",
                href: "/faq/#returns-exchange"
            },
            {
                name: "Shipping and Delivery",
                href: "/faq/#shipping-delivery",
                ariaLabel: "Frequently asked questions"
            },
            {
                name: "Request a Swatch",
                href: "/swatch-request"
            },
            {
                name: "Contact Us",
                href: "/contact-us"
            }, 
        ]
    },
    {
        heading: "Resources",
        links: [
            {
                name: "Free Design Services",
                href: "/design-services"
            },
            {
                name: "To the Trade",
                href: "/to-the-trade"
            },
            {
                name: "Affiliates",
                href: "/affiliates-apply-now"
            },
            {
                name: "Farrow & Ball",
                href: "/farrow-ball"
            },
            {
                name: "Protection Plan",
                href: "/extend-faq"
            },
            {
                name: "Citizens Pay™",
                href: "/citizens-pay-faq"
            }, 
        ]
    }, 
];
var designSkus = [
    "77469310",
    "77496064",
    "77496065",
    "77496066",
    "77496067",
    "77496068",
    "77496069",
    "77496070",
    "77496203",
    "77534784",
    "77534785",
    "77534786",
    "77534787",
    "77534788",
    "77535257",
    "77535258",
    "77535259",
    "77542926",
    "77542927",
    "77542928",
    "77542929",
    "77542930",
    "77542931",
    "77542932",
    "77542933",
    "77542934",
    "77542935",
    "77542936",
    "77542937",
    "77542938",
    "77542939",
    "77542940",
    "77576646",
    "77576647",
    "77576648",
    "77576649",
    "77576650",
    "77576651", 
];
var storeOperationHours = [
    "Monday-Friday 9 am - 7 pm EST",
    "Weekends & Holidays Closed", 
];


/***/ }),

/***/ 66778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gaProducts": function() { return /* binding */ gaProducts; },
/* harmony export */   "getBrandName": function() { return /* binding */ getBrandName; },
/* harmony export */   "productGA": function() { return /* binding */ productGA; },
/* harmony export */   "sendEventToGA": function() { return /* binding */ sendEventToGA; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29815);
/* harmony import */ var _codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27429);
/* harmony import */ var _allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48080);
/* harmony import */ var _checkIsExtendItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40136);
/* harmony import */ var _getCategoryName__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59126);
/* harmony import */ var _checkIsShippedShieldItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23406);










var getActualPrice = function(item, purchase) {
    var ref;
    var price = item.salePrice;
    if (item === null || item === void 0 ? void 0 : (ref = item.discounts) === null || ref === void 0 ? void 0 : ref.length) {
        var coupon = purchase ? item.couponAmount : item.discounts[0].discountedAmount;
        price = parseFloat((item.salePrice - coupon / item.quantity).toFixed(2));
    }
    return price;
};
var categoryNamesSorter = function(a, b) {
    var pathDiff = b.path.split("/").length - a.path.split("/").length;
    return pathDiff || b.name.length - a.name.length;
};
var getBrandName = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(lineItems) {
        var skus, ref, Product, skusData, itemMetadata;
        return _codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    skus = lineItems === null || lineItems === void 0 ? void 0 : lineItems.filter(function(param) {
                        var sku = param.sku;
                        return(// Filter out skus that are failing sku validation on product search - extended warranty & shippedshield
                        !!sku && !(0,_checkIsExtendItem__WEBPACK_IMPORTED_MODULE_3__.checkIsExtendItem)({
                            sku: sku
                        }) && !(0,_checkIsShippedShieldItem__WEBPACK_IMPORTED_MODULE_4__["default"])({
                            sku: sku
                        }));
                    }).map(function(item) {
                        return item.sku;
                    });
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
                    _ctx.next = 4;
                    return (0,_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 1704).then(__webpack_require__.bind(__webpack_require__, 81704))
                        ];
                    });
                case 4:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    Product = ref[0].Product;
                    _ctx.next = 9;
                    return Product.bySkus(skus !== null && skus !== void 0 ? skus : []);
                case 9:
                    skusData = _ctx.sent;
                    itemMetadata = {};
                    skusData.forEach(function(p) {
                        itemMetadata[p.id] = p;
                        itemMetadata[p.sku] = p;
                        p.variants.forEach(function(v) {
                            itemMetadata[v.sku] = p;
                        });
                    });
                    return _ctx.abrupt("return", function(sku) {
                        var ref;
                        return (itemMetadata === null || itemMetadata === void 0 ? void 0 : (ref = itemMetadata[sku]) === null || ref === void 0 ? void 0 : ref.brand) || "";
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBrandName(lineItems) {
        return _ref.apply(this, arguments);
    };
}();
var gaProducts = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(lineItems) {
        var purchase, itemMetadata, categoryName, brandName, _args = arguments;
        return _codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    purchase = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                    itemMetadata = {};
                    categoryName = function(sku) {
                        var ref, ref1, ref2;
                        return (ref1 = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(((ref = itemMetadata[sku]) === null || ref === void 0 ? void 0 : ref.category_info) || []).sort(categoryNamesSorter)) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.name;
                    };
                    _ctx.next = 5;
                    return getBrandName(lineItems);
                case 5:
                    brandName = _ctx.sent;
                    return _ctx.abrupt("return", lineItems === null || lineItems === void 0 ? void 0 : lineItems.map(function(item) {
                        return {
                            name: item.name,
                            id: item.sku,
                            salePrice: item.salePrice,
                            price: getActualPrice(item, purchase),
                            brand: brandName(item === null || item === void 0 ? void 0 : item.sku),
                            category: (item === null || item === void 0 ? void 0 : item.productId) ? categoryName(item === null || item === void 0 ? void 0 : item.sku) : "",
                            variant: item.variantId,
                            quantity: item.quantity
                        };
                    }));
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function gaProducts(lineItems) {
        return _ref.apply(this, arguments);
    };
}();
var sendEventToGA = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(lineItems, couponCode, pageName, eventName, cartTotal) {
        var sendToGA;
        return _codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    sendToGA = function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                            var ref, getCustomerDetails, ref1, customer, customerId, customerEmail, visitorType;
                            return _codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
                                        _ctx.next = 3;
                                        return (0,_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                                            return [
                                                __webpack_require__.e(/* import() */ 2054).then(__webpack_require__.bind(__webpack_require__, 32054)), 
                                            ];
                                        });
                                    case 3:
                                        _ctx.t1 = _ctx.sent;
                                        ref = (0, _ctx.t0)(_ctx.t1, 1);
                                        getCustomerDetails = ref[0].getCustomerDetails;
                                        (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("sending GA event", eventName);
                                        _ctx.prev = 7;
                                        ;
                                        customer = getCustomerDetails();
                                        customerId = customer === null || customer === void 0 ? void 0 : customer.customerId;
                                        customerEmail = customer === null || customer === void 0 ? void 0 : customer.customerEmail;
                                        visitorType = customerEmail ? "Logged In" : "Guest";
                                        if (!((ref1 = window.dataLayer) === null || ref1 === void 0)) {
                                            _ctx.next = 17;
                                            break;
                                        }
                                        void 0;
                                        _ctx.next = 32;
                                        break;
                                    case 17:
                                        _ctx.t2 = ref1;
                                        _ctx.t3 = eventName;
                                        _ctx.t4 = {
                                            couponCode: couponCode
                                        };
                                        _ctx.next = 22;
                                        return gaProducts(lineItems);
                                    case 22:
                                        _ctx.t5 = _ctx.sent;
                                        _ctx.t6 = cartTotal;
                                        _ctx.t7 = {
                                            actionField: _ctx.t4,
                                            products: _ctx.t5,
                                            total: _ctx.t6
                                        };
                                        _ctx.t8 = {
                                            currencyCode: "USD",
                                            checkout: _ctx.t7
                                        };
                                        _ctx.t9 = customerEmail;
                                        _ctx.t10 = visitorType;
                                        _ctx.t11 = customerId;
                                        _ctx.t12 = pageName;
                                        _ctx.t13 = {
                                            event: _ctx.t3,
                                            ecommerce: _ctx.t8,
                                            customerEmail: _ctx.t9,
                                            visitorType: _ctx.t10,
                                            customerId: _ctx.t11,
                                            pageName: _ctx.t12
                                        };
                                        _ctx.t2.push.call(_ctx.t2, _ctx.t13);
                                    case 32:
                                        _ctx.next = 37;
                                        break;
                                    case 34:
                                        _ctx.prev = 34;
                                        _ctx.t14 = _ctx["catch"](7);
                                        console.error(_ctx.t14);
                                    case 37:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    7,
                                    34
                                ]
                            ]);
                        }));
                        return function sendToGA() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    if (!window.loadedAndInteractive) {
                        _ctx.next = 6;
                        break;
                    }
                    _ctx.next = 4;
                    return sendToGA();
                case 4:
                    _ctx.next = 7;
                    break;
                case 6:
                    {
                        window.addEventListener("loadedAndInteractive", sendToGA, {
                            once: true
                        });
                    }
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendEventToGA(lineItems, couponCode, pageName, eventName, cartTotal) {
        return _ref.apply(this, arguments);
    };
}();
var productGA = function(param) {
    var name = param.name, sku = param.sku, price = param.price, salePrice = param.salePrice, variantId = param.variantId, categories = param.categories, event = param.event, brand = param.brand, quantity = param.quantity, _customerId = param.customerId, customerId = _customerId === void 0 ? 0 : _customerId, _customerEmail = param.customerEmail, customerEmail = _customerEmail === void 0 ? "" : _customerEmail, cartTotal = param.cartTotal;
    var sendToGA = function() {
        try {
            var ref, ref1;
            (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("productGA recording", {
                name: name,
                sku: sku,
                price: price,
                salePrice: salePrice,
                variantId: variantId,
                categories: categories,
                event: event,
                brand: brand,
                quantity: quantity,
                customerId: customerId,
                customerEmail: customerEmail,
                cartTotal: cartTotal
            });
            var keyName = event === "addToCart" ? "add" : "detail";
            var dataLayerEvent = {
                event: event,
                ecommerce: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                    currencyCode: "USD"
                }, keyName, {
                    products: [
                        {
                            name: name,
                            id: sku,
                            price: price,
                            // for grouped products like quilts, do you have a default that you can use?
                            salePrice: salePrice,
                            brand: brand,
                            variant: variantId,
                            category: (0,_getCategoryName__WEBPACK_IMPORTED_MODULE_9__.getCategoryName)(categories),
                            totalReviews: "",
                            averageRating: "",
                            inventoryCount: "In Stock",
                            quantity: "".concat(typeof quantity !== "undefined" ? quantity : "")
                        }
                    ]
                }),
                cartTotal: cartTotal,
                customerId: customerId,
                customerEmail: customerEmail,
                visitorType: customerEmail ? "Logged In" : "Guest",
                pageName: "pdp"
            };
            window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push({
                ecommerce: null
            }) // Clear the previous ecommerce object.
            ;
            window === null || window === void 0 ? void 0 : (ref1 = window.dataLayer) === null || ref1 === void 0 ? void 0 : ref1.push(dataLayerEvent);
        } catch (err) {
            (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("productGA Failed ".concat(String(err)));
        }
    };
    if (window.loadedAndInteractive) {
        sendToGA();
    } else {
        window.addEventListener("loadedAndInteractive", sendToGA, {
            once: true
        });
    }
};


/***/ }),

/***/ 40136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "checkIsExtendItem": function() { return /* binding */ checkIsExtendItem; }
/* harmony export */ });
/* harmony import */ var _data_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84749);

var checkIsExtendItem = function(variant) {
    return "".concat(variant.sku).includes(_data_constants__WEBPACK_IMPORTED_MODULE_0__.EXTEND_SKU);
};
/* harmony default export */ __webpack_exports__["default"] = (checkIsExtendItem);


/***/ }),

/***/ 23406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "checkIsShippedShieldItem": function() { return /* binding */ checkIsShippedShieldItem; }
/* harmony export */ });
/* harmony import */ var _data_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84749);

var checkIsShippedShieldItem = function(variant) {
    return "".concat(variant.sku).includes(_data_constants__WEBPACK_IMPORTED_MODULE_0__.SHIPPED_SHIELD_SKU);
};
/* harmony default export */ __webpack_exports__["default"] = (checkIsShippedShieldItem);


/***/ }),

/***/ 59126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getCategoryName": function() { return /* binding */ getCategoryName; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);

var getCategoryName = function(categories) {
    var ref;
    return ((ref = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(categories).sort(function(a, b) {
        var pathDiff = b.path.split("/").length - a.path.split("/").length;
        return pathDiff || b.name.length - a.name.length;
    })[0]) === null || ref === void 0 ? void 0 : ref.name) || "";
};
/* harmony default export */ __webpack_exports__["default"] = (getCategoryName);


/***/ }),

/***/ 8497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var MOBILE_SCREEN_WIDTH = 768;
var useMobileDetect = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(MOBILE_SCREEN_WIDTH), windowWidth = ref[0], setWindowWidth = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setWindowWidth(window.innerWidth);
        var windowWidthEventListener = function() {
            setWindowWidth(window === null || window === void 0 ? void 0 : window.innerWidth);
        };
        window === null || window === void 0 ? void 0 : window.addEventListener("resize", windowWidthEventListener);
        return function() {
            window === null || window === void 0 ? void 0 : window.removeEventListener("resize", windowWidthEventListener);
        };
    }, [
        windowWidth
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), isMobile = ref1[0], setIsMobile = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (windowWidth < MOBILE_SCREEN_WIDTH) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, [
        windowWidth
    ]);
    return isMobile;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMobileDetect);


/***/ }),

/***/ 94254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ product; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./services/Log.ts
var Log = __webpack_require__(27429);
// EXTERNAL MODULE: ./services/Configuration.js
var Configuration = __webpack_require__(16977);
// EXTERNAL MODULE: ./services/getSiteWideInitialProps.ts + 2 modules
var getSiteWideInitialProps = __webpack_require__(57927);
;// CONCATENATED MODULE: ./hooks/useIsCitizensPayScriptLoaded.ts

var useIsCitizensPayScriptLoaded = function() {
    var ref = (0,react.useState)(false), loaded = ref[0], setLoaded = ref[1];
    (0,react.useEffect)(function() {
        var loadedSetter = function() {
            return setLoaded(true);
        };
        document.addEventListener("CitizensPayScriptLoaded", loadedSetter);
        return function() {
            return document.removeEventListener("CitizensPayScriptLoaded", loadedSetter);
        };
    }, []);
    return loaded;
};
/* harmony default export */ var hooks_useIsCitizensPayScriptLoaded = ((/* unused pure expression or super */ null && (useIsCitizensPayScriptLoaded)));

// EXTERNAL MODULE: ./services/FramedCheckout/thirdPartyServices.ts
var thirdPartyServices = __webpack_require__(48034);
// EXTERNAL MODULE: ./helpers/allPromisesWithRetries.ts
var allPromisesWithRetries = __webpack_require__(48080);
// EXTERNAL MODULE: ./hooks/useMobileDetect.tsx
var useMobileDetect = __webpack_require__(8497);
// EXTERNAL MODULE: ./node_modules/@csc/dls/Row.js
var Row = __webpack_require__(69323);
// EXTERNAL MODULE: ./node_modules/@csc/dls/Col.js
var Col = __webpack_require__(79322);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./helpers/productOptionsForSkuMapper.ts





var getVariantOptionsMap = function(variant) {
    return variant.option_values.reduce(function(acc, optionValue) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, optionValue.option_id, optionValue.id));
    }, {});
};
var getProductVariantOptionsMap = function(variants) {
    return variants.reduce(function(acc, variant) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, variant.sku, getVariantOptionsMap(variant)));
    }, {});
};
var scoreMatchBetweenOptionsSets = function(target) {
    return function(option) {
        return Object.entries(target).reduce(function(score, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), optionId = _param[0], optionValue = _param[1];
            return score + (option[optionId] === optionValue ? 1 : 0);
        }, 0);
    };
};
var getSkusLinks = function(optionsValueIds, skusOptionsMap, currentSku) {
    return Object.entries(optionsValueIds).reduce(function(options, param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), optionId = _param[0], optionValuesIds = _param[1];
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), (0,_define_property/* default */.Z)({}, optionId, optionValuesIds.reduce(function(optionValues, optionSearchingId) {
            var ref, ref1;
            var idealSetOfOptionValues = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, skusOptionsMap[currentSku]), (0,_define_property/* default */.Z)({}, optionId, optionSearchingId));
            var skuHasTargetOptionValue = function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), skuMap = _param[1];
                return skuMap[optionId] === optionSearchingId;
            };
            var matchScoreTableForSkusAndOptions = Object.entries(skusOptionsMap).filter(skuHasTargetOptionValue).map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), sku = _param[0], candidateOptions = _param[1];
                return [
                    sku,
                    scoreMatchBetweenOptionsSets(idealSetOfOptionValues)(candidateOptions)
                ];
            });
            var hasAtLeastOneMatchedOption = function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), score = _param[1];
                return score > 0;
            };
            var highestScoredSkuForTargetOptionValue = ((ref = matchScoreTableForSkusAndOptions.filter(hasAtLeastOneMatchedOption).sort(function(param, param1) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), scoreA = _param[1], _param1 = (0,_sliced_to_array/* default */.Z)(param1, 2), scoreB = _param1[1];
                return scoreB - scoreA;
            })) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1[0]) || null;
            if (!highestScoredSkuForTargetOptionValue) {
                return optionValues;
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, optionValues), (0,_define_property/* default */.Z)({}, optionSearchingId, highestScoredSkuForTargetOptionValue));
        }, {})));
    }, {});
};
var getInitialOptions = function() {
    return {};
};
var optionsToOptionsMap = function(optionsInput) {
    return optionsInput.reduce(function(acc, option) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, option.id, option.option_values.map(function(ov) {
            return ov.id;
        })));
    }, getInitialOptions());
};
var productToOptionMapFetcher = function(param) {
    var product = param.product, targetSku = param.targetSku;
    (0,Log/* log */.cM)({
        product: product,
        targetSku: targetSku
    });
    var variantsSkuToOptions = getProductVariantOptionsMap(product.variants);
    var options = optionsToOptionsMap(product.options);
    return getSkusLinks(options, variantsSkuToOptions, targetSku);
};
/* harmony default export */ var productOptionsForSkuMapper = ((/* unused pure expression or super */ null && (productToOptionMapFetcher)));

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/product.tsx
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/jsx-props-no-spreading */ 


















var ProductOptions = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1532), __webpack_require__.e(1485), __webpack_require__.e(2791)]).then(__webpack_require__.bind(__webpack_require__, 60134)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60134)
            ];
        }
    }
});
var Default = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(3480), __webpack_require__.e(1587)]).then(__webpack_require__.bind(__webpack_require__, 20882)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20882)
            ];
        }
    }
});
var PdpTrackingServices = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1485), __webpack_require__.e(4528)]).then(__webpack_require__.bind(__webpack_require__, 85919)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85919)
            ];
        }
    }
});
var ProductContextProvider = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1485), __webpack_require__.e(653)]).then(__webpack_require__.bind(__webpack_require__, 41485)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41485)
            ];
        }
    }
});
var CitizensPayPdpWidget = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1485), __webpack_require__.e(6524)]).then(__webpack_require__.bind(__webpack_require__, 44523)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44523)
            ];
        }
    }
});
var ltkPdpRecEnabled = !!(Configuration.FEATURE_TOGGLES === null || Configuration.FEATURE_TOGGLES === void 0 ? void 0 : Configuration.FEATURE_TOGGLES.ltkPdpRecEnabled);
var collectionPdpEnabled = !!(Configuration.FEATURE_TOGGLES === null || Configuration.FEATURE_TOGGLES === void 0 ? void 0 : Configuration.FEATURE_TOGGLES.collectionPdpEnabled);
var ListrakRec = ltkPdpRecEnabled ? dynamic_default()(__webpack_require__.e(/* import() */ 2508).then(__webpack_require__.bind(__webpack_require__, 72508)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72508)
            ];
        }
    }
}) : function() {
    return null;
};
var CollectionRecommendationWidget = collectionPdpEnabled ? dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(9961), __webpack_require__.e(1485), __webpack_require__.e(1031)]).then(__webpack_require__.bind(__webpack_require__, 73506)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73506)
            ];
        }
    }
}) : function() {
    return null;
};
var ProductDetails = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(3996), __webpack_require__.e(3906), __webpack_require__.e(1485), __webpack_require__.e(5770), __webpack_require__.e(2771)]).then(__webpack_require__.bind(__webpack_require__, 45811)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45811)
            ];
        }
    }
});
var ProductImages = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1485), __webpack_require__.e(7767)]).then(__webpack_require__.bind(__webpack_require__, 29050)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29050)
            ];
        }
    }
});
var AddProductToCartForm = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(9669), __webpack_require__.e(4544), __webpack_require__.e(8883), __webpack_require__.e(1485), __webpack_require__.e(639), __webpack_require__.e(9646), __webpack_require__.e(2084), __webpack_require__.e(2750)]).then(__webpack_require__.bind(__webpack_require__, 34683)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34683)
            ];
        }
    }
});
var Breadcrumbs = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1485), __webpack_require__.e(576)]).then(__webpack_require__.bind(__webpack_require__, 4716)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4716)
            ];
        }
    }
});
var AccordionProductDetails = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(6860), __webpack_require__.e(3316), __webpack_require__.e(1485), __webpack_require__.e(1767)]).then(__webpack_require__.bind(__webpack_require__, 24041)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24041)
            ];
        }
    }
});
var BrandDescription = dynamic_default()(__webpack_require__.e(/* import() */ 6673).then(__webpack_require__.bind(__webpack_require__, 16673)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16673)
            ];
        }
    }
});
var ProductSchema = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1485), __webpack_require__.e(8092)]).then(__webpack_require__.bind(__webpack_require__, 16926)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16926)
            ];
        }
    }
});
var ProductPage = function(param) {
    var product = param.product, sitewideBanner = param.sitewideBanner, megaNav = param.megaNav, defaultVariantSku = param.defaultVariantSku, brand_Info = param.brand_Info, productOptionsToSkuMap = param.productOptionsToSkuMap, imagesToPreload = param.imagesToPreload;
    var ref;
    var ref1 = (0,getSiteWideInitialProps.useClientSideCartAndUser)(), cart = ref1.cart, setCart = ref1.setCart, user = ref1.user;
    var citizensPayScriptLoaded = useIsCitizensPayScriptLoaded();
    var ref2 = (0,react.useState)(Configuration.ENABLE_CITIZENS), shouldShowCitizensPay = ref2[0], setShouldShowCitizensPay = ref2[1];
    var isMobile = (0,useMobileDetect/* default */.Z)();
    (0,react.useEffect)(function() {
        var getCitizensDisplayState = function() {
            var citizensPayCookieEnabled = false;
            try {
                // eslint-disable-next-line react-hooks/rules-of-hooks
                citizensPayCookieEnabled = (0,thirdPartyServices.useCitizensPayCookieToggle)();
            } catch (e) {
                (0,Log/* error */.vU)("Failed to check if citizensPayCookie is enabled");
            }
            setShouldShowCitizensPay(Configuration.ENABLE_CITIZENS || citizensPayCookieEnabled);
        };
        getCitizensDisplayState();
    }, []);
    // Computed values from state and props
    var metaTags = {
        title: String(product === null || product === void 0 ? void 0 : product.page_title),
        description: String(product === null || product === void 0 ? void 0 : product.meta_description)
    };
    var brand_description = String((brand_Info === null || brand_Info === void 0 ? void 0 : (ref = brand_Info.category) === null || ref === void 0 ? void 0 : ref.meta_description) || "");
    var brand_description_title = "About The Brand";
    var showCitizensPayWidget = shouldShowCitizensPay && citizensPayScriptLoaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: imagesToPreload.map(function(imgUrl, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        as: "image",
                        href: imgUrl,
                        id: "preloaded-image-".concat(index)
                    }, imgUrl);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Default, {
                user: user,
                sitewideBanner: sitewideBanner,
                megaNav: megaNav,
                meta: metaTags,
                cart: cart,
                onUpdateCart: setCart,
                pageType: "product",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductContextProvider, {
                    cart: cart,
                    setCart: setCart,
                    product: product,
                    defaultVariantSku: defaultVariantSku,
                    user: user,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdpTrackingServices, {
                            cart: cart,
                            user: user,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.ZP, {
                                    cols: 1,
                                    "data-currency-code": "USD",
                                    className: "mt-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.ZP, {
                                            gapX: "lg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                                    span: 12,
                                                    className: "md:hidden",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails, {})
                                                }),
                                                showCitizensPayWidget && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                                    span: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CitizensPayPdpWidget, {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                                    span: {
                                                        sm: 12,
                                                        lg: 7
                                                    },
                                                    className: "w-full",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImages, {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.ZP, {
                                                    span: {
                                                        sm: 12,
                                                        lg: 5
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.ZP, {
                                                            gap: "xl",
                                                            cols: 1,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "hidden md:block",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails, {})
                                                                }),
                                                                showCitizensPayWidget && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(CitizensPayPdpWidget, {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptions, {
                                                                    productOptionsToSkuMap: productOptionsToSkuMap
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AddProductToCartForm, {
                                                                    setCart: setCart
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionProductDetails, {})
                                                            ]
                                                        }),
                                                        brand_description && /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandDescription, {
                                                            brand_description_title: brand_description_title,
                                                            brand_description: String(brand_description)
                                                        })
                                                    ]
                                                }),
                                                ltkPdpRecEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                                    span: {
                                                        sm: 12,
                                                        lg: 12
                                                    },
                                                    className: "w-full",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListrakRec, {})
                                                }) : null
                                            ]
                                        })
                                    ]
                                }),
                                collectionPdpEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionRecommendationWidget, {
                                    title: "Related Items"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSchema, {})
                    ]
                })
            })
        ]
    });
};
ProductPage.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(ctx) {
        var ref, query, sku, queryWithoutSlug, ref1, getSiteWideInitialProps, Product, Brand, fetchProductBrand, ref2, ref3, product, brand_Info, siteWideProps, defaultVariantSku, productOptionsToSkuMap, imagesToPreload, params, location, // Tell 302 proxy not to cache response
        // https://docs.layer0.co/guides/caching#section_caching_private_responses
        ref4, ref5, ref6, ref7, ref8, ref9;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    query = ctx.query;
                    sku = String(query.primarySku);
                    queryWithoutSlug = (0,_object_spread/* default */.Z)({}, query);
                    delete queryWithoutSlug.slug;
                    delete queryWithoutSlug.id;
                    _ctx.t0 = _sliced_to_array/* default */.Z;
                    _ctx.next = 10;
                    return (0,allPromisesWithRetries/* default */.Z)(function() {
                        return [
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 57927)),
                            __webpack_require__.e(/* import() */ 1704).then(__webpack_require__.bind(__webpack_require__, 81704)),
                            __webpack_require__.e(/* import() */ 51).then(__webpack_require__.bind(__webpack_require__, 80051)), 
                        ];
                    });
                case 10:
                    _ctx.t1 = _ctx.sent;
                    ref1 = (0, _ctx.t0)(_ctx.t1, 3);
                    getSiteWideInitialProps = ref1[0].getSiteWideInitialProps;
                    Product = ref1[1].Product;
                    Brand = ref1[2].Brand;
                    (0,Log/* log */.cM)("Product page getInitialProps", {
                        sku: sku
                    });
                    fetchProductBrand = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(product) {
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        if (!(product === null || product === void 0 ? void 0 : product.brand_id)) {
                                            _ctx.next = 6;
                                            break;
                                        }
                                        _ctx.t0 = product;
                                        _ctx.next = 4;
                                        return Brand.getBrandById(product.brand_id);
                                    case 4:
                                        _ctx.t1 = _ctx.sent;
                                        return _ctx.abrupt("return", [
                                            _ctx.t0,
                                            _ctx.t1
                                        ]);
                                    case 6:
                                        return _ctx.abrupt("return", [
                                            product,
                                            null
                                        ]);
                                    case 7:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function fetchProductBrand(product) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    _ctx.t2 = _sliced_to_array/* default */.Z;
                    _ctx.next = 20;
                    return Promise.all([
                        Product.bySku({
                            sku: sku
                        }).then(fetchProductBrand),
                        getSiteWideInitialProps(ctx), 
                    ]);
                case 20:
                    _ctx.t3 = _ctx.sent;
                    ref2 = (0, _ctx.t2)(_ctx.t3, 2);
                    ref3 = (0,_sliced_to_array/* default */.Z)(ref2[0], 2);
                    product = ref3[0];
                    brand_Info = ref3[1];
                    siteWideProps = ref2[1];
                    if (product) {
                        _ctx.next = 28;
                        break;
                    }
                    throw new Error("Product not found for sku: ".concat(sku));
                case 28:
                    defaultVariantSku = typeof query.sku === "string" ? query.sku : product.variants[0].sku;
                    productOptionsToSkuMap = productToOptionMapFetcher({
                        product: product,
                        targetSku: defaultVariantSku
                    });
                    (0,Log/* log */.cM)("productOptionsMap for ".concat(defaultVariantSku), {
                        defaultVariantSku: defaultVariantSku,
                        productOptionsToSkuMap: productOptionsToSkuMap
                    });
                    imagesToPreload = (((ref = product === null || product === void 0 ? void 0 : product.variants.find(function(v) {
                        return v.sku === defaultVariantSku;
                    })) === null || ref === void 0 ? void 0 : ref.images) || []).map(function(image) {
                        return image.url_square;
                    }).slice(0, 6);
                    return _ctx.abrupt("return", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, siteWideProps), {
                        imagesToPreload: imagesToPreload,
                        productOptionsToSkuMap: productOptionsToSkuMap,
                        defaultVariantSku: defaultVariantSku,
                        product: product,
                        brand_Info: brand_Info
                    }));
                case 35:
                    _ctx.prev = 35;
                    _ctx.t4 = _ctx["catch"](0);
                    (0,Log/* error */.vU)("PDP SSR Failed", _ctx.t4);
                    params = new URLSearchParams({
                        pdpslug: "".concat(String(ctx.asPath || "") || "").replace(/\//g, "")
                    });
                    location = "".concat(Configuration.SHOP_ORIGIN, "/PageNotFound?").concat(String(params));
                    if ( true && window.location.href) {
                        window.location.href = location;
                    } else if (ctx.res) {
                        ;
                        (ref4 = ctx.res) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.setHeader) === null || ref5 === void 0 ? void 0 : ref5.call(ref4, "cache-control", "private");
                        (ref6 = ctx.res) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.writeHead) === null || ref7 === void 0 ? void 0 : ref7.call(ref6, 302, {
                            location: location
                        });
                        (ref8 = ctx.res) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.end) === null || ref9 === void 0 ? void 0 : ref9.call(ref8);
                    }
                    _ctx.next = 43;
                    return new Promise(function(resolve) {
                        return setTimeout(resolve, 15000);
                    }) // Max 15s to redirect
                    ;
                case 43:
                    throw _ctx.t4;
                case 44:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                35
            ]
        ]);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var product = (ProductPage);


/***/ }),

/***/ 36511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "asyncStandardizeCart": function() { return /* binding */ asyncStandardizeCart; },
/* harmony export */   "getCart": function() { return /* binding */ getCart; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var _codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48080);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27429);








var formCartStandardizer = function(param) {
    var generateLineItemsFromBCCart = param.generateLineItemsFromBCCart, getCustomItems = param.getCustomItems, standardizeCart = param.standardizeCart;
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(bcCart) {
            var ref, lineItems, customItems, standardizedCart;
            return _codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return generateLineItemsFromBCCart(bcCart);
                    case 3:
                        lineItems = _ctx.sent;
                        customItems = getCustomItems({
                            lineItems: lineItems,
                            customItems: bcCart === null || bcCart === void 0 ? void 0 : (ref = bcCart.lineItems) === null || ref === void 0 ? void 0 : ref.customItems
                        });
                        standardizedCart = standardizeCart((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, bcCart), {
                            email: bcCart.email || "",
                            lineItems: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(lineItems).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(customItems))
                        }));
                        return _ctx.abrupt("return", standardizedCart);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(bcCart) {
            return _ref.apply(this, arguments);
        };
    }();
};
var asyncStandardizeCart = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(bcCart) {
        var ref, standardizeCart, generateLineItemsFromBCCart, getCustomItems, standardizer;
        return _codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
                    _ctx.next = 3;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 6916).then(__webpack_require__.bind(__webpack_require__, 66916)),
                            __webpack_require__.e(/* import() */ 4352).then(__webpack_require__.bind(__webpack_require__, 14352)),
                            __webpack_require__.e(/* import() */ 5729).then(__webpack_require__.bind(__webpack_require__, 9342)), 
                        ];
                    });
                case 3:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 3);
                    standardizeCart = ref[0].standardizeCart;
                    generateLineItemsFromBCCart = ref[1].generateLineItemsFromBCCart;
                    getCustomItems = ref[2].getCustomItems;
                    standardizer = formCartStandardizer({
                        generateLineItemsFromBCCart: generateLineItemsFromBCCart,
                        getCustomItems: getCustomItems,
                        standardizeCart: standardizeCart
                    });
                    return _ctx.abrupt("return", standardizer(bcCart));
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function asyncStandardizeCart(bcCart) {
        return _ref.apply(this, arguments);
    };
}();
var getCart = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, ref1, Axios, standardizeCart, generateLineItemsFromBCCart, getCustomItems, ref2, assertBCCart, assertBCCarts, data, rawCart, standardizer, standardCart;
        return _codebuild_output_src020387934_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .log */ .cM)("getCart START");
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
                    _ctx.next = 4;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 9669).then(__webpack_require__.t.bind(__webpack_require__, 9669, 23)),
                            __webpack_require__.e(/* import() */ 6916).then(__webpack_require__.bind(__webpack_require__, 66916)),
                            __webpack_require__.e(/* import() */ 4352).then(__webpack_require__.bind(__webpack_require__, 14352)),
                            __webpack_require__.e(/* import() */ 5729).then(__webpack_require__.bind(__webpack_require__, 9342)),
                            __webpack_require__.e(/* import() */ 6888).then(__webpack_require__.bind(__webpack_require__, 6888)), 
                        ];
                    });
                case 4:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 5);
                    ref1 = ref[0];
                    Axios = ref1.default;
                    standardizeCart = ref[1].standardizeCart;
                    generateLineItemsFromBCCart = ref[2].generateLineItemsFromBCCart;
                    getCustomItems = ref[3].getCustomItems;
                    ref2 = ref[4];
                    assertBCCart = ref2.assertBCCart;
                    assertBCCarts = ref2.assertBCCarts;
                    _ctx.next = 16;
                    return Axios.get("/api/storefront/cart?include=lineItems.physicalItems.options");
                case 16:
                    data = _ctx.sent.data;
                    assertBCCarts(data);
                    rawCart = data[0];
                    if (rawCart) {
                        _ctx.next = 21;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 21:
                    assertBCCart(rawCart);
                    standardizer = formCartStandardizer({
                        generateLineItemsFromBCCart: generateLineItemsFromBCCart,
                        getCustomItems: getCustomItems,
                        standardizeCart: standardizeCart
                    });
                    _ctx.next = 25;
                    return standardizer(rawCart);
                case 25:
                    standardCart = _ctx.sent;
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .log */ .cM)("getCart END", {
                        cart: standardCart
                    });
                    return _ctx.abrupt("return", standardCart);
                case 28:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCart() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (getCart);


/***/ }),

/***/ 79322:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
var validSelectors = [
    "sm",
    "md",
    "lg",
    "xl",
    "2xl"
];
var Col = function Col(_a) {
    var _b = _a.span, span = _b === void 0 ? 1 : _b, start = _a.start, end = _a.end, _c = _a.divRef, divRef = _c === void 0 ? null : _c, style = _a.style, children = _a.children, className = _a.className, rest = __rest(_a, [
        "span",
        "start",
        "end",
        "divRef",
        "style",
        "children",
        "className"
    ]); //  Must be wrapped inside <Row>
    //  span: Number of columns this Column will take on the grid can receive a static number or object per breakpoint
    //    note: the maximum number is the value defined in Parent <Row>'s cols attribute
    //    possible values:  auto(adjust to size) | 1-12 | full
    //    example: {sm: 12, md:6 } => Takes 12 columns on mobile and 6 columns on screen medium and bigger
    //
    //  start:  Use the start-{n} and end-{n} utilities to make an element start or end at the nth grid line. 
    //  end:    Use the start-{n} and end-{n} utilities to make an element start or end at the nth grid line. 
    var set = function set(tailWindClass, obj) {
        if (obj === void 0) {
            obj = NaN;
        }
        if (_typeof(obj) !== "object") {
            if (isNaN(obj)) {
                return "";
            }
            obj = {
                sm: obj
            };
        }
        var classes = "";
        if (_typeof(obj) === "object") {
            Object.entries(obj).filter(function(_a) {
                var _b = __read(_a, 1), i = _b[0];
                return validSelectors.includes(i);
            }).forEach(function(_a) {
                var _b = __read(_a, 2), key = _b[0], value = _b[1];
                classes += " ".concat(key !== "sm" ? "".concat(key, ":") : "").concat(tailWindClass).concat(value);
            });
        }
        return classes;
    };
    return /*#__PURE__*/ React__default["default"].createElement("div", _extends({
        className: "".concat(set("col-span-", span)).concat(set("col-start-", start)).concat(set("col-end-", end), " ").concat(className || ""),
        ref: divRef,
        style: style
    }, rest), children);
};
__webpack_unused_export__ = Col;
exports.ZP = Col; //# sourceMappingURL=Col.js.map


/***/ }),

/***/ 69323:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var Row = function Row(_a) {
    var _b = _a.divRef, divRef = _b === void 0 ? null : _b, _c = _a.cols, cols = _c === void 0 ? 12 : _c, _d = _a.gap, gap = _d === void 0 ? "md" : _d, _e = _a.gapX, gapX = _e === void 0 ? gap : _e, _f = _a.gapY, gapY = _f === void 0 ? gap : _f, children = _a.children, _g = _a.style, style = _g === void 0 ? {} : _g, className = _a.className, rest = __rest(_a, [
        "divRef",
        "cols",
        "gap",
        "gapX",
        "gapY",
        "children",
        "style",
        "className"
    ]);
    var gapDictionary = {
        "xs": "1",
        "sm": "2",
        "md": "4",
        "lg": "6",
        "xl": "8",
        "2xl": "12",
        "3xl": "16"
    };
    var genClasses = function genClasses() {
        var classes = "grid ";
        if (typeof cols === "number") {
            classes += " grid-cols-".concat(cols);
        } else if (_typeof(cols) === "object") {
            classes += " grid-cols-".concat(cols.xs || 12);
            Object.keys(cols).forEach(function(key) {
                if (key !== "xs") {
                    classes += " ".concat(key, ":grid-cols-").concat(cols[key]);
                }
            });
        }
        var addAxisGap = function addAxisGap(classes, gap, separator) {
            if (separator === void 0) {
                separator = "";
            }
            var isSinglySetGap = _typeof(gap) === "object" && Object.keys(gap).length === 1;
            gap = _typeof(gap) === "object" && Object.keys(gap).length < 1 ? "md" : gap;
            if (typeof gap === "string") {
                return classes + " gap".concat(separator, "-").concat(gapDictionary[gap]);
            } else if (isSinglySetGap) {
                return classes + " gap".concat(separator, "-").concat(gapDictionary[gap[Object.keys(gap)[0]]]);
            }
            var gapKeys = [
                "xs",
                "sm",
                "md",
                "lg",
                "xl",
                "2xl",
                "3xl"
            ];
            var defaultASLowestDefinedBreakpoint = gapKeys.find(function(key) {
                return gap === null || gap === void 0 ? void 0 : gap[key];
            });
            var gapMinimumValue = gap === null || gap === void 0 ? void 0 : gap[defaultASLowestDefinedBreakpoint];
            classes += " gap".concat(separator, "-").concat(gapDictionary[gapMinimumValue || "md"]);
            gapKeys.forEach(function(breakpoint) {
                if (breakpoint === defaultASLowestDefinedBreakpoint || !(gap === null || gap === void 0 ? void 0 : gap[breakpoint])) {
                    return;
                }
                var gapValue = gapDictionary[(gap === null || gap === void 0 ? void 0 : gap[breakpoint]) || "md"];
                classes += " ".concat(breakpoint, ":gap").concat(separator, "-").concat(gapValue);
            });
            return classes;
        };
        classes = addAxisGap(classes, gapX, "-x");
        classes = addAxisGap(classes, gapY, "-y");
        return "".concat(classes).concat(className !== undefined ? " ".concat(className) : "");
    };
    return /*#__PURE__*/ React__default["default"].createElement("div", _extends({
        ref: divRef,
        className: genClasses(),
        style: style
    }, rest), children);
};
__webpack_unused_export__ = Row;
exports.ZP = Row; //# sourceMappingURL=Row.js.map


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9080,7927,8034,9774,2888,179], function() { return __webpack_exec__(85353); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);